import SharedEpics from './shared/allEpics'
import AllUserEpics from './user/allEpics' // Artwork User - includes Collections, Favorites used in Browse ( algolia driven pages ) and PDP

export default [...SharedEpics, ...AllUserEpics]